import {EnvConstructionModificationVerboseDomain} from "../../domain/env/EnvConstructionModificationVerboseDomain"
import {EnvConstructionId} from "../../id/env/EnvConstructionId"
import {EnvConstructionModificationId} from "../../id/env/EnvConstructionModificationId"
import {UserId} from "../../id/user/UserId"
import {UserValueObject} from "../user/UserValueObject"
import {EnvConstructionValueObject} from "./EnvConstructionValueObject"
import {VerboseValueObject} from "ts-protocol-extension"

/**
 * 작업 수정 이력 상세
 */
export class EnvConstructionModificationVerboseValueObject implements VerboseValueObject, EnvConstructionModificationVerboseDomain {
    /**
     * 기본키
     */
    id: EnvConstructionModificationId
    /**
     * 수정자 ID
     */
    creatorId: UserId
    /**
     * 작업 ID
     */
    envConstructionId: EnvConstructionId
    /**
     * 제목
     */
    title: string
    /**
     * 내용
     */
    body: string
    /**
     * 시작일
     */
    startAt: Date
    /**
     * 종료일
     */
    endAt: Date
    /**
     * 수정일
     */
    createdAt: Date
    /**
     * 수정자 ID
     */
    creator: UserValueObject
    /**
     * 작업 ID
     */
    envConstruction: EnvConstructionValueObject

    constructor(o: Record<keyof EnvConstructionModificationVerboseDomain, any>) {
        this.id = BigInt(o.id)
        this.creatorId = BigInt(o.creatorId)
        this.envConstructionId = BigInt(o.envConstructionId)
        this.title = String(o.title)
        this.body = String(o.body)
        this.startAt = new Date(o.startAt)
        this.endAt = new Date(o.endAt)
        this.createdAt = new Date(o.createdAt)
        this.creator = new UserValueObject(o.creator)
        this.envConstruction = new EnvConstructionValueObject(o.envConstruction)
    }
}
